<template>
  <div class="button" :class="className" @click="tap">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    // full normal TODO small large
    size: {
      type: String,
      default: 'normal'
    },
    hasRadius: {
      type: Boolean,
      default: true
    },
    notClick: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className () {
      const radius = this.hasRadius ? 'radius' : ''
      const disable = this.notClick ? 'disable' : ''
      return `${this.size} ${radius} ${disable}`
    }
  },
  methods: {
    tap () {
      !this.notClick && this.$emit('click')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";
.button {
  box-sizing: border-box;
  text-align: center;
  color: #fff;
  background-color: $ucar_main_button;
  flex: 1 0 33%;
  &.normal {
    font-size: $ucar_font_h5;
    width: 240px;
    height: 70px;
    line-height: 70px;
  }
  &.full {
    font-size: $ucar_font_h4;
    height: 88px;
    line-height: 88px;
    font-weight: 700;
  }
  &.radius {
    border-radius: 5px;
  }
  &.disable {
    background-color: #999;
    opacity: 0.7;
  }
}
.button + .button {
  margin-left: 30px;
}
</style>
